<template>
  <svg
    width="162"
    height="54"
    viewBox="0 0 162 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_196_83)">
      <path
        d="M70.1812 19.6713H65.6909V21.179H65.3525C64.3991 20.0714 62.9227 19.2714 60.8622 19.2714C56.71 19.2714 53.4191 22.8715 53.4191 27.764C53.4191 32.626 56.7407 36.2875 60.8929 36.2875C63.2304 36.2875 64.5221 35.3951 65.3832 34.1644H65.7216V35.8859L67.5054 35.8876H70.194L70.1814 31.4567L70.1812 19.6713ZM61.877 31.9795C59.7241 31.9795 57.9708 30.3486 57.9708 27.7947C57.9708 25.2407 59.693 23.6099 61.8461 23.6099C63.9682 23.6099 65.7523 25.1177 65.7523 27.7947C65.7523 30.0718 64.2145 31.9795 61.877 31.9795Z"
        fill="currentColor"
      />
      <path
        d="M18.2508 14.3568L15.2413 19.8878H21.5882L27.7337 30.3491H21.3867L15.2413 19.8878L12.3739 14.3568H6.09888L2.94361 19.8878H9.19948L15.3445 30.3484H8.99908L2.89861 19.965L-0.0705566 25.1686L6.05766 35.8872H12.3739L15.3447 30.3489L15.3449 30.3491L18.3322 35.887H24.6495L30.7604 25.1684L24.6772 14.3568H18.2508Z"
        fill="currentColor"
      />
      <path
        d="M39.0886 35.8872H43.6713V27.6716H52.0373V23.3945H43.6713V18.656H52.6217V14.348H39.0886V35.8872Z"
        fill="currentColor"
      />
      <path
        d="M137.186 26.9025L142.138 19.6713H136.817L133.311 25.1177H131.958V12.8095H127.467V35.8874H131.958V29.241H133.404L137.033 35.8874H142.384L137.186 27.2408V26.9025Z"
        fill="currentColor"
      />
      <path
        d="M118.154 23.5483C120.061 23.5483 121.538 24.6254 122.03 26.4717L126.182 25.4255C125.136 21.3638 121.968 19.2711 118.031 19.2711C112.926 19.2711 109.604 23.056 109.604 27.7947C109.604 32.4718 112.926 36.2873 118.031 36.2873C121.968 36.2873 125.167 34.2257 126.182 30.1949L121.999 29.1794C121.507 30.964 120.061 32.0102 118.154 32.0102C115.725 32.0102 114.156 30.1639 114.156 27.7947C114.156 25.3945 115.694 23.5483 118.154 23.5483Z"
        fill="currentColor"
      />
      <path
        d="M106.166 12.3172C104.628 12.3172 103.49 13.4558 103.49 14.9019C103.49 16.3789 104.628 17.5173 106.166 17.5173C107.673 17.5173 108.81 16.3787 108.81 14.9019C108.81 13.4558 107.672 12.3172 106.166 12.3172Z"
        fill="currentColor"
      />
      <path
        d="M146.546 24.1331C146.546 23.4254 147.284 22.9639 148.361 22.9639C149.56 22.9639 150.544 23.6409 150.883 24.7794L154.758 23.7332C154.051 20.8098 151.683 19.2716 148.299 19.2716C144.701 19.2716 142.117 21.5177 142.117 24.3178C142.117 30.7795 150.606 28.5333 150.606 31.2104C150.606 31.9795 149.929 32.5027 148.576 32.5027C147.038 32.5027 145.685 31.8257 145.5 30.3179L141.563 31.0257C142.025 34.6258 144.916 36.2876 148.361 36.2876C152.574 36.2876 155.127 34.0412 155.127 30.7795C155.127 24.564 146.546 26.6562 146.546 24.1331Z"
        fill="currentColor"
      />
      <path
        d="M94.4534 21.8253H94.1457V19.6715H89.7168V35.8874H94.1764V28.2872C94.1764 25.2717 95.7758 23.7332 98.2361 23.7332H99.8969V19.2716H98.6054C96.7602 19.2714 95.1608 20.4406 94.4534 21.8253Z"
        fill="currentColor"
      />
      <path
        d="M101.183 23.7475H103.859V35.8874H108.318V19.2714H101.183V23.7475Z"
        fill="currentColor"
      />
      <path
        d="M81.1114 19.2714C78.62 19.2714 77.2667 20.3792 76.4979 21.333H76.1595V12.8095H71.6692V35.8872H76.1595V34.3794H76.4979C77.2667 35.3949 78.5586 36.2873 80.8654 36.2873C85.0483 36.2873 88.4315 32.6255 88.4315 27.7638C88.4313 23.0253 85.2944 19.2714 81.1114 19.2714ZM79.9732 32.0411C77.6357 32.0411 76.0979 30.0718 76.0979 27.7947C76.0979 25.1179 77.8817 23.5485 80.0041 23.5485C82.1877 23.5485 83.8794 25.2407 83.8794 27.7947C83.8794 30.3486 82.1265 32.0411 79.9732 32.0411Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_196_83">
        <rect
          width="162"
          height="54"
          fill="currentColor"
        />
      </clipPath>
    </defs>
  </svg>
</template>
